import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from './app/store';
import reportWebVitals from './reportWebVitals';
import App from "./App";
import './scss/style.scss';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  /*<React.StrictMode>*/
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  /*</React.StrictMode>*/
);

// STRICT MODE REMOVED BECAUSE OF TESTING, IN PRODUCTION IT WON'T DO DOUBLE

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
